import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE } from "tools/webservice";
import { PermissionToCloseDto, UnderwriterPermissionToClosePageInformation, AddAdditionalContactDto, KeepOpenWithExtensionDto, UnderwriterPermissionToCloseTemplates } from "interfaces/Mueller.Business.Models";

export const isInPermissionToCloseWorkflow = (controlIdNumber: number, successCallback: (isInWorkflow: boolean) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/closeout/${controlIdNumber}/permission`,
  successCallback,
  errorCallback,
  mountedRef
});

export const getPermissionToCloseEmailTemplates = (controlIdNumber: number, successCallback: (templates: UnderwriterPermissionToCloseTemplates) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/closeout/${controlIdNumber}/permission-email-templates`,
  successCallback,
  errorCallback,
  mountedRef
});

export const requestPermissionToClose = (controlIdNumber: number, payload: PermissionToCloseDto, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${controlIdNumber}/permission`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const cancelPermissionToClose = (controlIdNumber: number, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/closeout/${controlIdNumber}/permission`,
  successCallback,
  errorCallback,
  mountedRef
});

export const getPermissionToClosePageInfo = (workItemId: string, successCallback: (data: UnderwriterPermissionToClosePageInformation) => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/closeout/${workItemId}/permission-submit`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_Ok = (workItemId: string, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/ok`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_MoreInfo = (workItemId: string, payload: AddAdditionalContactDto[], successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/more-info`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_TryAgain = (workItemId: string, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/try-again`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_KeepOpen = (workItemId: string, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/keep-open`,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_KeepOpenWithExtension = (workItemId: string, payload: KeepOpenWithExtensionDto, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/keep-open-extend`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});

export const submitPermissionToClose_KeepOpenWithNote = (workItemId: string, note: string, successCallback: () => void, errorCallback: ()=> void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/closeout/${workItemId}/permission-submit/keep-open-with-note`,
  payload: note,
  successCallback,
  errorCallback,
  mountedRef,
});